import { render, staticRenderFns } from "./PptxIcon.vue?vue&type=template&id=5861069e&"
import script from "./PptxIcon.vue?vue&type=script&lang=js&"
export * from "./PptxIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports